export default function isSelectableAsMaster(recordIds, recordSecurities, master) {
  return recordIds.reduce(function (acc, recordId, index) {
    var security = recordSecurities[index];
    var check = recordId === recordIds[master] ? security.editable : security.deletable;
    return acc && check;
  }, true);
}